/**
 * 
 * @fileoverview AppRoutingModule
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
*/

import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuardService } from './services/auth/guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'panel',
    loadChildren: () => import('./pages/panel/panel.module').then( m => m.PanelPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [GuardService]
  },
  {
    path: 'saving',
    loadChildren: () => import('./pages/saving/saving.module').then( m => m.SavingPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'credit/:id',
    loadChildren: () => import('./pages/credit/credit.module').then( m => m.CreditPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'payment/:id',
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'credit-new',
    loadChildren: () => import('./pages/credit-new/credit-new.module').then( m => m.CreditNewPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'saving-new',
    loadChildren: () => import('./pages/saving-new/saving-new.module').then( m => m.SavingNewPageModule),
    canActivate: [GuardService]
  },
  {
    path: 'modal/code',
    loadChildren: () => import('./pages/modals/code/code.module').then( m => m.CodePageModule)
  },
  {
    path: 'modal/alert-credit',
    loadChildren: () => import('./pages/modals/alert-credit/alert-credit.module').then( m => m.AlertCreditPageModule)
  },
  {
    path: 'modal/alert-saving',
    loadChildren: () => import('./pages/modals/alert-saving/alert-saving.module').then( m => m.AlertSavingPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
